const TimelineSchema = (props) => ({
  title: 'AgSUS Linha do Tempo',
  fieldsets: [
    { id: 'default', title: 'Seção', fields: ['eyebrow', 'title', 'variant'] },
    { id: 'items', title: 'Marcos', fields: ['items'] },
  ],
  properties: {
    eyebrow: {
      title: 'Etiqueta',
      description: 'Texto curto em caixa alta, acima do título.',
    },
    title: { title: 'Título da seção' },
    variant: {
      title: 'Fundo da seção',
      choices: [
        ['default', 'Paper (branco)'],
        ['alt', 'Surface (off-white)'],
      ],
      default: 'default',
    },
    items: {
      title: 'Marcos',
      description: 'Cada marco tem data, título e descrição. Ordem mantida.',
      widget: 'object_list',
      schema: {
        title: 'Marco',
        fieldsets: [
          { id: 'default', title: 'Default', fields: ['date', 'title', 'desc'] },
        ],
        properties: {
          date: {
            title: 'Data',
            description: 'Ex.: "Set / 2023", "Mar / 2024", "Jul 2024".',
          },
          title: { title: 'Título' },
          desc: { title: 'Descrição', widget: 'textarea' },
        },
        required: ['title'],
      },
    },
  },
  required: [],
});

export default TimelineSchema;
